import { TNotifyFileChangeData } from "@/types/public";
import { LocalParticipant, RemoteParticipant, Room } from "livekit-client";

export function useNotifyFileChange({
  user,
  room,
}: {
  room?: Room | undefined;
  user?: LocalParticipant | RemoteParticipant;
}) {
  const notifyFileChange = (
    target: "file",
    fileId: string | null,
    type: "add" | "delete" | "dec" = "add"
  ) => {
    if (!room || !user || !room.localParticipant) return;
    const local = room.localParticipant;
    if (!local) return;
    const msg: TNotifyFileChangeData = {
      type: type,
      from: local.identity ?? "unknown",
      to: user.identity ?? "unknown",
      at: Date.now(),
      target,
      fileId,
    };

    try {
      const payload = new TextEncoder().encode(JSON.stringify(msg));
      local.publishData(payload, {
        reliable: false,
        topic: target,
      });
    } catch (e) {
      console.warn("failed to publish cam-state", e);
    }
  };

  return { notifyFileChange };
}
